import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import CventFooterStyles from './Footer.less';

/* eslint-disable no-script-url */
const noOp = 'javascript:void(0);';

/**
 * A component that display the cvent's footer content.
 */
export default class Footer extends React.Component {
  static displayName = 'Footer';
  static propTypes = {
    /* translate text resolver for text */
    translate: PropTypes.func,
    /* whether to display the cvent logo or not */
    showCventLogo: PropTypes.bool,
    /* whether to display copyright information */
    showCopyrightInformation: PropTypes.bool,
    /* whether to display Event Management Software link */
    showEventManagementSoftware: PropTypes.bool,
    /* whether to display Mobile Event Apps link */
    showMobileEventApps: PropTypes.bool,
    /* whether to display Inquisium link */
    showInquisium: PropTypes.bool,
    /* whether to display Event Venues link */
    showEventVenues: PropTypes.bool,
    /* whether to display Strategic Meetings Management link */
    showStrategicMeetingsManagement: PropTypes.bool,
    /* whether to display privacy policy link */
    showPrivacyPolicy: PropTypes.bool,
    /* whether the links are clickable */
    enableHyperlink: PropTypes.bool,
    /* whether to display terms of use (end user license agreement) link */
    showTermsOfUse: PropTypes.bool,
    /* display extra policy links */
    additionalPolicyLinks: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })),
    /* custom privacy policy URL */
    privacyPolicyUrl: PropTypes.string
  };
  static defaultProps = {
    classes: CventFooterStyles,
    privacyPolicyUrl: 'https://www.cvent.com/en/privacy-policy.shtml'
  };

  getHrefValue = (href) => this.props.enableHyperlink ? href : noOp;

  renderLogo() {
    return (
      <a
        {...resolve(this.props, 'logoImage')}
        href={this.getHrefValue('http://www.cvent.com/')}
        target="_blank"
      >Cvent</a>
    );
  }

  renderLink(href, localizationString) {
    // NOTE using localizationString as key under the assumption that they are all unique.
    return (
      <li {...resolve(this.props, 'list')} key={localizationString}>
        <a {...resolve(this.props, 'link')} href={this.getHrefValue(href)} target="_blank">
          {this.props.translate(localizationString)}
        </a>
      </li>
    );
  }

  render() {
    const {
      translate,
      showCventLogo,
      showCopyrightInformation,
      showEventManagementSoftware,
      showMobileEventApps,
      showInquisium,
      showEventVenues,
      showStrategicMeetingsManagement,
      showPrivacyPolicy,
      showTermsOfUse,
      additionalPolicyLinks,
      privacyPolicyUrl
    } = this.props;

    return (
      <footer {...resolveTestId(this.props)} {...resolve(this.props, 'container')}>
        {showCventLogo && this.renderLogo()}
        {showCopyrightInformation &&
        <span {...resolve(this.props, 'copyright')}>{translate('GuestWebsite_Footer_Copyright__resx')}</span>}
        <ul {...resolve(this.props, 'marketingLinks')}>
          {[
            showEventManagementSoftware &&
            this.renderLink(
              'http://www.cvent.com/en/event-management-software/',
              '_cventFooter_eventManagementSoftware__resx'),
            showMobileEventApps &&
            this.renderLink('http://www.cvent.com/en/mobile-event-apps/', '_cventFooter_mobileEventApps__resx'),
            showInquisium &&
            this.renderLink('http://www.inquisium.com/', '_cventFooter_surveySoftware__resx'),
            showEventVenues &&
            this.renderLink('http://www.cvent.com/rfp/hotels', '_cventFooter_eventVenues__resx'),
            showStrategicMeetingsManagement &&
            this.renderLink(
              'http://www.cvent.com/en/strategic-meetings-management/',
              '_cventFooter_strategicMeetingsManagement__resx')
          ]}
        </ul>
        <ul {...resolve(this.props, 'policyLinks')}>
          {[
            showTermsOfUse &&
            this.renderLink('http://www.cvent.com/en/eula.shtml', '_cventFooter_endUserLicenceAgreement__resx'),
            showPrivacyPolicy &&
            this.renderLink(privacyPolicyUrl, '_cventFooter_privacyPolicy__resx'),
            ...(additionalPolicyLinks && additionalPolicyLinks.length >= 1 &&
              additionalPolicyLinks.map(link => this.renderLink(link.url, link.text)))
          ]}
        </ul>
      </footer>
    );
  }
}
